import { css } from '@emotion/react';
import { useTheme } from '@mui/material';

const useStyles = () => {
  const theme = useTheme();

  const { primary, text, divider } = theme.palette;
  const { md } = theme.breakpoints;

  const collapseWrapper = css`
    border-radius: 0;
    min-height: unset;
    box-shadow: none;
    border-top: 1px solid ${divider};
    width: 100%;
    background-color: inherit;

    & .MuiAccordionSummary-root {
      min-height: 54px;
    }

    & .MuiAccordionSummary-root.Mui-expanded {
      min-height: 54px;
    }

    & .MuiButtonBase-root.MuiAccordionSummary-root {
      padding: 0;
    }

    & .MuiAccordionSummary-expandIconWrapper {
      margin: 0 15px;
    }
  `;

  const collapseHeader = css`
    margin: 0;
    color: ${primary.default};
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
    width: 100%;

    & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(0deg);
    }
  `;

  const collapseDetails = css`
    color: ${text.secondary};
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    padding: 0 20px;
  `;

  const collapseIconWrapper = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0;
    padding: 10px;
    cursor: pointer;
    background: transparent;

    &:focus-visible {
      outline: none;
      border: 0;
    }

    & img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: all 0.25s ease;
    }

    @media (max-width: ${`${md}px`}) {
      margin-right: 20px;
    }
  `;

  return {
    collapseWrapper,
    collapseHeader,
    collapseDetails,
    collapseIconWrapper,
  };
};

export default useStyles;
